<template>
    <div id="membresia">
        <!--ESTE ES PARA EL ADMINISTRADOR -->
        <div class="row">
            <div v-if="kind_user==='admin'" class="col-12 col-md-4 mb-3">
                <select data-select="on" v-model="prov_role_id" name="ciudad" id="ciudad"
                        v-on:change="selectCompanyByRoleProvider($event)" class="required">
                    <option :value="0">Tipo de Proveedor*</option>
                    <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                        {{ prov.name }}
                    </option>
                </select>
            </div>

            <div v-if="kind_user==='admin'" class="col-12 col-md-4 mb-3">
                <select data-select="on" v-model="prov_id" name="provider" id="provider"
                        v-on:change="selectSpecialtiesAndServices($event)" class="required">
                    <option :value="0">Proveedores*</option>
                    <option v-for="lprov in list_providers"
                            :value="lprov.id"
                            :key="lprov.id"
                            :data-sesiones="lprov.honorariosSesiones"
                            :data-reduccion="lprov.honorariosReduccion"
                            :data-padecimiento="lprov.honorariosPadecimiento"
                            :data-electro="lprov.honorariosElectro">
                        {{ lprov.genericName }}
                    </option>
                </select>
            </div>

            <div v-if="kind_user==='admin'" class="col-12 col-md-4 mb-3">
                <date-picker inputName="fecha_atencion" input-class="mx-input scr-input" v-model="fecha_atencion"
                             format="YYYY-MM-dd" placeholder="Fecha de atención" lang="es"></date-picker>
            </div>

            <div class="col-12 col-md-6 mb-3"
                 v-if="detail_specialist_array.relspecialistspecialty && detail_specialist_array.relspecialistspecialty.length>0">
                <select data-select="on" v-model="member.specialty_id" name="specialty_id" id="specialty_id"
                        class="required">
                    <option :value="0">Selecciona una especialidad*</option>
                    <option v-for="(esp, index) in detail_specialist_array.relspecialistspecialty" v-if="esp.specialty"
                            :value="esp.specialty_id"
                            :key="esp.id">
                        {{ esp.specialty ? esp.specialty.especialidad : '' }}
                    </option>
                </select>
            </div>

            <div class="col-12 col-md-6 mb-3"
                 v-if="detail_specialist_array.relspecialistservices && detail_specialist_array.relspecialistservices.length >0">
                <select data-select="on" v-model="member.type_serv" name="type_serv" id="type_serv" class="required">
                    <option :value="0">Tipo de Servicio*</option>

                    <option v-for="(service, index) in detail_specialist_array.relspecialistservices"
                            :value="service.service_id"
                            :key="service.id">
                        {{ service.service && service.service.servicio ? service.service.servicio : '' }}
                    </option>

                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <!--BUSQUEDA POR  SKU-->
                <form class="sku">
                    <input v-on:keyup="formatearTexto()" v-model="member.sku" minlength="13" maxlength="17" type="text"
                           name="sku" class="al-inputs required scr-input" id=""
                           placeholder="ej. XXX-XXXX-XXXX || XXX-XXXX-XXXX-XXX">
                    <button type="button" class="formSubmit" v-on:click="searchMember('sku')">Buscar Membresía</button>
                </form>
            </div>
            <div class="col-12 col-sm-6">
                <!--BUSQUEDA POR  INFORMACION DEL USUARIO-->
                <form class="memberInfo">
                    <div class="row">
                        <div class="col-12 col-sm-4">
                            <input v-model="member.nombre" type="text" name="sku" class="al-inputs required scr-input"
                                   id="nombre" placeholder="Nombre(s)">

                        </div>
                        <div class="col-12 col-sm-4">
                            <input v-model="member.paterno" type="text" name="sku" class="al-inputs required scr-input"
                                   id="paterno" placeholder="Apellido Paterno">

                        </div>
                        <div class="col-12 col-sm-4">
                            <input v-model="member.materno" type="text" name="sku" class="al-inputs required scr-input"
                                   id="materno" placeholder="Apellido Materno">

                        </div>
                        <div class="col-12 col-sm-6">
                            <select id="estado" v-model="member.estado" v-on:change="selectCities($event)" name="estado"
                                    data-select="on" class="required">
                                <option :value="0">Seleccione un Estado*</option>
                                <option v-for="state in states" :value="state.id" :key="state.id">
                                    {{ state.estado }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-6">
                            <select data-select="on" v-model="member.ciudad" name="ciudad" id="ciudad" class="required">
                                <option :value="0">Selecciona un Ciudad*</option>
                                <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id">
                                    {{ city.ciudad }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-12">
                            <button type="button" class="formSubmit" v-on:click="searchMember('memberInfo')">Buscar
                                Usuario
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {membersService} from '../../Services/Members.service';
import {estadoService} from '../../Services/States.service';
import {myMixins} from "../mixins/myMixins";
import {statescitiesService} from "../../Services/Statescities.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {rolesService} from "../../Services/Roles.service";
//import {supplierambulancesService} from "../../Services/SupplierAmbulances.service";
//import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
//import {supplierlaboratoriesService} from "../../Services/SupplierLaboratories.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";
//import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
//import {supplieropticiansService} from "../../Services/SupplierOpticians.service";

export default {
    name: 'membresia',
    mixins: [myMixins],
    components: {
        DatePicker: () => import('vue2-datepicker'),
    },
    props: {
        kind_user: {
            type: String,
            required: false,
            default: ''
        },
        rel_specialist_specialties: {
            type: Array,
            required: false
        },
        rel_specialist_services: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            member: {
                nombre: '',
                paterno: '',
                materno: '',
                estado: 0,
                ciudad: 0,
                sku: '',
                specialty_id: 0,
                type_serv: 0,
                fecha_atencion: ''
            },
            sku: '',
            memberData: {},
            states: [],
            cities: [],
            list_providers: [],
            providers: [],
            prov_role_id: 0,
            prov_id: 0,
            honorariosSesiones: 0,
            honorariosReduccion: 0,
            honorariosPadecimiento: 0,
            honorariosElectro: 0,
            fecha_atencion: '',
            specialties: [],
            detail_specialist_array: [],
            type_specialty_array: [],
            selectedServices: [],
        }
    },
    methods: {
        async selectProvider() {
            this.providers = await rolesService.getProvidersForSinester();
            //console.log('providers', this.providers);
        },
        async selectCompanyByRoleProvider($e) {
            let id = this.stateId($e);
            let columnName = this.columnMapping[Number(id)];

            if (columnName) {
                let providers = await this.getProvidersByRole(id);
                // Procesa el nombre de la columna según sea necesario
                this.list_providers = this.processColumnNames(providers, columnName);
            }
        },
        async searchMember($typeSearch) {
            //console.log('searchMember', $typeSearch);
            let resp = {};

            if (this.kind_user === 'admin' || this.kind_user === 'specialist') {
                if (this.kind_user === 'admin' && this.validateFields()) {
                    this.member.fecha_atencion = this.fecha_atencion;
                }
                if (this.valFormulariosV3($typeSearch)) {
                    resp = await membersService.getMembers(this.member);
                }
            }

            //console.log('L215 resp = ', resp);

            if (this.prov_role_id) {
                resp.prov_role_id = this.prov_role_id;
            }

            resp.prov_id = this.prov_id;
            resp.specialty_id = this.member.specialty_id;
            resp.type_serv = this.member.type_serv;
            resp.fecha_atencion = this.fecha_atencion;
            resp.honorariosSesiones = this.honorariosSesiones;
            resp.honorariosReduccion = this.honorariosReduccion;
            resp.honorariosPadecimiento = this.honorariosPadecimiento;
            resp.honorariosElectro = this.honorariosElectro;

            switch (resp.process) {
                case 'success':
                    this.getAlert('yes_service');
                    //console.log('resp', resp);
                    this.memberData = resp;
                    this.$emit('memberStatus', this.memberData);
                    break;
                case 'no_service':
                    this.getAlert('no_service');
                    this.memberData = '';
                    break;
                case 'limit':
                    this.getAlert('max_limit');
                    this.memberData = '';
                    break;
            }

        },
        async selectCities($e) {
            this.cities = await statescitiesService.getCitiesByState($e.target.value);
        },
        async getProvidersByRole(id) {
            switch (Number(id)) {
                /* case 3:
                     return supplierambulancesService.getMany({});*/
                case 4:
                    return supplierspecialistService.getMany({});
                /*  case 7:
                      return supplierinstitutionsService.getMany({});
                  case 10:
                      return supplierlaboratoriesService.getMany({});*/
                case 11:
                    return supplierdentistsService.getMany({});
                /*case 12:
                    return supplierradiologyService.getMany({});
                case 13:
                    return supplieropticiansService.getMany({});*/
                default:
                    return [];
            }
        },
        selectSpecialtiesAndServices($e) {
            //NECESITO OBTENER Y CREAR UN LISTADO CON LO QUE CONTIENE relspecialistservices QUE ES UN ARRAY DE SERVICIOS
            this.detail_specialist_array = this.list_providers.find(provider => provider.id === Number($e.target.value));
            const selectedOption = $e.target.options[$e.target.selectedIndex];
            this.honorariosSesiones = selectedOption.getAttribute('data-sesiones');
            this.honorariosReduccion = selectedOption.getAttribute('data-reduccion');
            this.honorariosPadecimiento = selectedOption.getAttribute('data-padecimiento');
            this.honorariosElectro = selectedOption.getAttribute('data-electro');
        },
        formatearTexto() {
            //console.log('formatearTexto');
            // Obtén el valor actual del campo de texto y conviértelo a mayúsculas
            let texto = this.member.sku.toUpperCase();

            // Elimina caracteres no alfanuméricos y permite solo letras y números
            texto = texto.replace(/[^a-zA-Z0-9]/g, '');

            // Divide el texto en secciones
            let primeraParte = texto.substring(0, 3);
            let segundaParte = texto.substring(3, 7);
            let terceraParte = texto.substring(7, 11);
            let cuartaParte = texto.substring(11, 14);

            // Formatea el texto con guiones si la longitud es suficiente
            let textoFormateado = '';
            if (primeraParte) textoFormateado += primeraParte;
            if (segundaParte) textoFormateado += `-${segundaParte}`;
            if (terceraParte) textoFormateado += `-${terceraParte}`;
            if (cuartaParte) textoFormateado += `-${cuartaParte}`;

            // Actualiza el valor del campo de texto con el formato deseado
            this.member.sku = textoFormateado;
        },
        processColumnNames(providers, columnName) {

            //console.log('providers', providers, 'columnName', columnName)

            // En otros casos, simplemente mapea los nombres de columna
            return providers.map(provider => ({
                id: provider.id,
                genericName: provider[columnName],
                honorariosSesiones: provider['honorarios_sesiones'],
                honorariosReduccion: provider['honorarios_reduccion'],
                honorariosPadecimiento: provider['honorarios_padecimiento'],
                honorariosElectro: provider['honorarios_electrocardiograma'],
                relspecialistspecialty: provider.relspecialistspecialty ? provider.relspecialistspecialty.filter(specialty => specialty !== null) : [],
                relspecialistservices: provider.relspecialistservices ? provider.relspecialistservices.filter(service => service.service && service.service.servicio !== null) : []
            }));
        },
        validateFields() {
            const validations = {
                prov_role_id: () => {
                    if (this.prov_role_id === 0) {
                        return 'prov_role_id';
                    }
                    return true;
                },
                prov_id: () => {
                    if (this.prov_id === 0) {
                        return 'prov_id';
                    }
                    return true;
                },
                specialty_id: () => {
                    if (this.detail_specialist_array.relspecialistspecialty && this.detail_specialist_array.relspecialistspecialty.length > 0 && this.member.specialty_id === 0) {
                        return 'specialty_id';
                    }
                    return true;
                },
                type_serv: () => {
                    if (this.detail_specialist_array.relspecialistservices && this.detail_specialist_array.relspecialistservices.length > 0 && this.member.type_serv === 0) {
                        return 'type_serv';
                    }
                    return true;
                },
                fecha_atencion: () => {
                    if (this.fecha_atencion === '') {
                        return 'fecha_atencion';
                    }
                    return true;
                }
                // Agrega más validaciones según sea necesario
            };

            for (const validation in validations) {
                const result = validations[validation]();
                if (result !== true) {
                    this.getAlert(result);
                    return false;
                }
            }

            return true;
        }
    },
    async mounted() {

        if (this.kind_user === 'specialist') {
            this.detail_specialist_array.relspecialistspecialty = this.rel_specialist_specialties;
            this.detail_specialist_array.relspecialistservices = this.rel_specialist_services;
        }

        this.states = await estadoService.getMany();
        await this.selectProvider();
    }
}
</script>
<style scoped>
.mx-datepicker {
    margin: 0 !important;
}

#membresia .al-inputs {
    margin-top: 0;
}

#membresia .formSubmit {
    margin-top: 18px;
}

#membresia .alert-info {
    background: #eaf7ff !important;
    color: #323232;
}
</style>
